import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { FiberNid } from '@app/shared/models/fiber-nid.model';


@Component({
    selector: 'app-fiber-nid-card',
    templateUrl: './fiber-nid-card.component.html',
    styleUrls: ['./fiber-nid-card.component.css'],
    standalone: false
})
export class FiberNidCardComponent implements OnInit, OnDestroy {
    @Input() fiberNid: FiberNid;

    constructor() {}

    ngOnInit() {}
    ngOnDestroy() {}


}